const env = process.env.ENV;

class Configs {
  get ENV() {
    return env;
  }

  get CUB_HOST(): string {
    if (env === 'prd') return 'cliente.cub.com.br';
    if (env === 'stg') return 'cliente.cubsystems-hml.com';
    return 'cliente.cubsystems-hml.com';
  }

  get WHITELABEL_ASSETS_BASE_URL(): string {
    if (env === 'prd') return 'https://media.cub.com.br/whitelabel-assets';
    if (env === 'stg') return 'https://media.cubsystems-hml.com/whitelabel-assets';
    return 'https://media.cubsystems-hml.com/whitelabel-assets';
  }

  get BFF_BASE_URL(): string | undefined {
    if (env === 'stg' || env === 'prd') return undefined;
    return 'https://xxxxxxx.com/v1';
  }

  get MOCK_REQUESTS() {
    return env === 'dev';
  }

  get MIN_VALUE_TO_SHOW_LATE_PAYMENT_DAYS(): number {
    return 6;
  }
}

export default new Configs();
